"use strict";

exports.__esModule = true;
var _DeviceTypeSelector = require("./DeviceTypeSelector");
Object.keys(_DeviceTypeSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceTypeSelector[key]) return;
  exports[key] = _DeviceTypeSelector[key];
});